import { configureStore } from "@reduxjs/toolkit";
import accountReducer from "./reducers/accounts/account.reducer";
import attributeReducer from "./reducers/items/attributes/attribute.refucer";
import priceListReducer from "./reducers/items/prices/price.reducer";
import productReducer from "./reducers/items/product.reducer";
import categoryReducer from "./reducers/items/categories/category.reducer";
import shoppingCartReducer from "./reducers/shoppingCart/shoppingCart.reducer";
import { persistCartStateMiddleware } from "../middlewares/shoppingCart/shoppingCart.middleware";
import itemGroupsReducer from "./reducers/items/categories/itemGroups/itemGroup.reducer";
import businessCustomerReducer from "./reducers/businessCustomer/businessCustomer.reducer";
import orderReducer from "./reducers/orders/order.reducer";
import websiteConfigurationReducer from "./reducers/websiteConfiguration/websiteConfiguration.reducer";
import catalogReducer from "./reducers/catalog/catalog.reducer";

const store = configureStore({
  reducer: {
    itemGroupsReducer: itemGroupsReducer, // Use a key to identify this slice of the state
    categoryReducer: categoryReducer, // Use a key to identify this slice of the state
    shoppingCart: shoppingCartReducer, // Added shopping cart reducer
    accountReducer: accountReducer, // Use a key to identify this slice of the state
    businessCustomerReducer: businessCustomerReducer,
    orderReducer: orderReducer, // Added order reducer
    websiteConfigurationReducer: websiteConfigurationReducer, // Added website Configuration reducer
    catalogReducer: catalogReducer, // Added catalog reducer
    // attributeReducer: attributeReducer, // Use a key to identify this slice of the state
    // priceListReducer: priceListReducer, // Use a key to identify this slice of the state
    productReducer: productReducer, // Use a key to identify this slice of the state
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(persistCartStateMiddleware), // Add middleware for cart persistence
});

export default store;
